import React from 'react'
import CreditCardModal from '../CreditCardModal'

import './index.css'

export default function ConfigCreditCardModal({ creditCard, onSave }) {

  return (
    <div>
      <CreditCardModal creditCard={creditCard} />
    </div>
  )
}